import { render } from "./exceptionalArticles.vue?vue&type=template&id=53edf367"
import script from "./exceptionalArticles.vue?vue&type=script&lang=js"
export * from "./exceptionalArticles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__